import { DB_COLLECTION_NAMES, Module } from "@constants";
import { useGetDocument } from "../useGetDocument";
import { DocumentActions } from "../firestoreHookTypes";

function useGetModule(moduleId: string): [Module | null, DocumentActions] {
  const [fetchedModule, moduleActions] = useGetDocument<Module>(
    DB_COLLECTION_NAMES.MODULES,
    moduleId,
  );
  if (fetchedModule) return [fetchedModule, moduleActions];
  return [
    null,
    {
      update: () => Promise.resolve(),
      delete: () => Promise.resolve(),
    },
  ];
}

export { useGetModule };
